module.exports = __webpack_public_path__ + "img/LogoLeoLearning.91037acc.png";